import * as React from 'react';
import DateRangeModal from "../../../misc/components/queryTable/DateRangeModal";
import {
    Query,
    QueryCondition,
    QueryFilter,
    SpirometrySessionMetadata
} from "../../../misc/api/apiTypes";

export const CreatedAtFilterMember = "CreatedDateTime";
export const CreatedAtHeader = "Created At";

interface CreatedAtFilterProps {
    onApply: (from: QueryFilter, to: QueryFilter) => void;
    onClose: () => void;
    query: Query<SpirometrySessionMetadata>;
}

const GetFromQueryFilter = (query: Query<SpirometrySessionMetadata>): QueryFilter => {
    return query.Filters.find(filter => filter.Member === CreatedAtFilterMember && filter.Condition === QueryCondition.GreaterThanOrEqual);
}

const GetToQueryFilter = (query: Query<SpirometrySessionMetadata>): QueryFilter => {
    return query.Filters.find(filter => filter.Member === CreatedAtFilterMember && filter.Condition === QueryCondition.LessThanOrEqual);
}

const CreatedAtFilterModal = ({ onApply, query, onClose }: CreatedAtFilterProps): JSX.Element => {

    const fromFilterValue = GetFromQueryFilter(query) || { Values: [] };
    const toFilterValue = GetToQueryFilter(query) || { Values: [] };

    const [from, setFrom] = React.useState<string>(fromFilterValue.Values[0]);
    const [to, setTo] = React.useState<string>(toFilterValue.Values[0]);

    return (<DateRangeModal
        header={CreatedAtHeader + ' Filter'}
        show={true}
        to={to}
        from={from}
        onChange={(_from, _to) => {
            setFrom(_from);
            setTo(_to);
        }}
        onApply={() => {
            onApply({
                Member: CreatedAtFilterMember,
                Condition: QueryCondition.GreaterThanOrEqual,
                Values: !!from ? [from] : []
            }, {
                Member: CreatedAtFilterMember,
                Condition: QueryCondition.LessThanOrEqual,
                Values: !!to ? [to] : []
            });
        }}
        onClear={() => {
            onApply({
                Member: CreatedAtFilterMember,
                Condition: QueryCondition.GreaterThanOrEqual,
                Values: []
            }, {
                Member: CreatedAtFilterMember,
                Condition: QueryCondition.LessThanOrEqual,
                Values: []
            });
        }}
        onClose={onClose}
    />)
}

export default CreatedAtFilterModal;
